<template>
    <div class="d-md-flex align-items-center justify-content-between mb-2 mt-2">
        <div>
            <h4 class="main-title mb-0">Circles</h4>
        </div>
    </div>
    <div class="row g-3 mb-2">
        <div class="col-xl-12" style="height: fit-content;">
            <form class="card card-one" @submit.prevent="submitForm()">
                <div class="card-header">
                    <h6 class="card-title" v-if="status">New Circle</h6>
                    <h6 class="card-title" v-else>Update Circle</h6>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <label class="form-label">Sub Division</label><span class="text-danger"> *</span>
                            <select class="form-select border-0 border-bottom" :class="{ 'is-invalid': errors.sub_division_id }"
                                v-model="circle.sub_division_id" ref="sub_division_id">
                                <option value="">Select Sub Division</option>
                                <option v-for="sd in sub_divisions" :key="sd.sub_division_id" :value="sd.sub_division_id">{{ sd.sub_division }}</option>
                            </select>
                            <span v-if="errors.sub_division_id" class="invalid-feedback">{{ errors.sub_division_id[0] }}</span>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Circle</label><span class="text-danger"> *</span>
                            <input type="text" class="form-control border-0 border-bottom" placeholder="Circle name"
                                :class="{ 'is-invalid': errors.circle }" v-model="circle.circle" />
                            <span v-if="errors.circle" class="invalid-feedback">{{ errors.circle[0] }}</span>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">E-Mail</label>
                            <input type="email" class="form-control border-0 border-bottom" placeholder="Email" :class="{'is-invalid': errors?.email}" v-model="circle.email" />
                            <span v-if="errors?.email" class="invalid-feedback">{{ errors?.email[0] }}</span>
                        </div>
                        <div class="col-md-12 mt-3">
                            <label class="form-label">Address</label>
                            <textarea class="form-control border-0 border-bottom" cols="30" rows="2" placeholder="Address" v-model="circle.address"></textarea>
                            <span v-if="errors?.address" class="invalid-feedback">{{ errors?.address[0] }}</span>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-end">
                    <button class="btn btn-danger me-2" type="button" @click="discard()"><i class="ri-prohibited-line me-1"></i>Discard</button>
                    <button class="btn btn-primary" type="submit">
                        <span v-if="status"><i class="ri-save-line me-1"></i> Submit</span>
                        <span v-else><i class="ri-save-line me-1"></i> Update</span>
                    </button>
                </div>
            </form>
        </div>
        <div class="col-xl-12">
            <div class="card card-one">
                <div class="card-header">
                    <h6 class="card-title">Circles</h6>
                </div>
                <div class="card-body">
                    <input type="text" class="form-control mb-2" placeholder="Search" v-model="meta.search" @keypress.enter="search()">
                    <div class="table-responsive" style="overflow-y:scroll; height: 60vh;">
                        <table class="table text-nowrap table-bordered table-hover table-bottom-border mb-0">
                            <thead>
                                <tr style="background-color: #f5f5f5;">
                                    <th class="text-center">Sl No.</th>
                                    <th>Sub Division</th>
                                    <th>Circle</th>
                                    <th class="text-center">E-Mail</th>
                                    <th>Order</th>
                                    <th class="text-center">Status</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(c, key) in circles" :key="c.circle_id">
                                    <td class="text-center">{{ meta.from + key }}</td>
                                    <td>{{ c.sub_division && c.sub_division.sub_division }}</td>
                                    <td>{{ c.circle }}</td>
                                    <td>{{ c.email }}</td>
                                    <td class="text-center">{{ c.order }}</td>
                                    <td class="text-center">
                                        <div class="form-switch">
                                            <input class="form-check-input" type="checkbox" role="switch"
                                                :id="'circle' + c.circle_id" :checked="c.status" :value="c.status"
                                                @change="deleteCircle(c)" />
                                            <label class="custom-control-label" :for="'circle' + c.circle_id"></label>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <a href="javascript:void(0)" class="text-primary me-2" v-if="c.status" @click="editCircle(c)"><i class="ri-edit-line fs-18 lh-1"></i></a>
                                    </td>
                                </tr>
                                <tr v-if="circles.length === 0">
                                    <td colspan="7" class="text-center">No Records Found</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-footer">
                    <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import Pagination from "@/components/Pagination.vue";

let paginateCirclesCancel = null;

export default {
    components: { Pagination },
    data() {
        return {
            meta: {
                search: "",
                order_by: "asc",
                keyword: "order",
                per_page: 10,
                totalRows: 0,
                page: 1,
                lastPage: 1,
                from: 1,
                maxPage: 1,
            },
            status: true,
            circle: {
                circle_id: "",
                sub_division_id: "",
                circle: "",
                email: "",
                address: "",
            },
            circles: [],
            sub_divisions: [],
            errors: [],
        };
    },
    mounted() {
        this.getSubDivisions();
        this.$nextTick(() => {
            this.index();
            if (this.$refs.sub_division_id) this.$refs.sub_division_id.focus();
        });
    },
    methods: {
        submitForm() {
            if (this.status) this.create();
            else this.update();
        },
        index() {
            let vm = this;
            if (paginateCirclesCancel) {
                paginateCirclesCancel();
                paginateCirclesCancel = null;
            }
            const payload = {
                search: this.meta.search || "",
                order_by: this.meta.order_by || "asc",
                keyword: this.meta.keyword || "circle",
                per_page: this.meta.per_page || 10,
                page: this.meta.page || 1,
            };
            const source = axios.CancelToken.source();
            paginateCirclesCancel = () => source.cancel("canceled");

            axios
                .post(this.$store.state.apiUrl + "paginateCircles", payload, {
                    headers: { Authorization: "Bearer " + this.$store.getters.token },
                    cancelToken: source.token,
                })
                .then((response) => {
                    paginateCirclesCancel = null;
                    if (vm._isDestroyed) return;
                    const res = response?.data;
                    let list = [];
                    if (Array.isArray(res)) {
                        list = res;
                    } else if (res && typeof res === "object" && res.data !== undefined) {
                        list = Array.isArray(res.data) ? res.data : [];
                    }
                    list = (list || []).filter(Boolean);
                    vm.circles.splice(0, vm.circles.length, ...list);
                    vm.$forceUpdate();
                    const meta = res?.meta || {};
                    vm.meta.totalRows = meta.total ?? list.length;
                    vm.meta.lastPage = meta.last_page ?? 1;
                    vm.meta.from = meta.from ?? 1;
                    vm.meta.maxPage = Math.min(vm.meta.lastPage, 3);
                })
                .catch((error) => {
                    paginateCirclesCancel = null;
                    if (axios.isCancel(error)) return;
                    if (!error?.response) return;
                    if (error.response.data && error.response.data.message === "Unauthenticated.") {
                        this.$store.dispatch("logout");
                        window.location.href = "/#/login";
                        window.location.reload();
                        return;
                    }
                    vm.$set(vm, "circles", []);
                    vm.errors = error.response?.data?.errors || {};
                    this.$store.dispatch("error", error.response?.data?.message || "Error loading circles");
                });
        },
        create() {
            let vm = this;
            let loader = this.$loading.show();
            const payload = { ...vm.circle };
            delete payload.order;
            delete payload.circle_id;
            this.$store.dispatch("post", { uri: "addCircle", data: payload })
                .then(() => {
                    loader.hide();
                    this.$store.dispatch("success", "Circle created successfully");
                    vm.discard();
                    vm.index();
                })
                .catch((error) => {
                    loader.hide();
                    vm.errors = error.response?.data?.errors || {};
                    this.$store.dispatch("error", error.response?.data?.message || "Error creating circle");
                });
        },
        update() {
            let vm = this;
            let loader = this.$loading.show();
            this.$store.dispatch("post", { uri: "updateCircle", data: vm.circle })
                .then(() => {
                    loader.hide();
                    this.$store.dispatch("success", "Circle updated successfully");
                    vm.discard();
                })
                .catch((error) => {
                    loader.hide();
                    vm.errors = error.response?.data?.errors || {};
                    this.$store.dispatch("error", error.response?.data?.message || "Error updating circle");
                });
        },
        editCircle(c) {
            if (!c) return;
            this.circle = { ...c };
            this.status = false;
            if (this.$refs.sub_division_id) this.$refs.sub_division_id.focus();
        },
        deleteCircle(c) {
            let vm = this;
            let loader = this.$loading.show();
            this.$store.dispatch("post", { uri: "deleteCircle", data: { circle_id: c.circle_id } })
                .then((response) => {
                    loader.hide();
                    this.$store.dispatch("success", response.data.message);
                    vm.discard();
                })
                .catch((error) => {
                    loader.hide();
                    this.$store.dispatch("error", error.response?.data?.message || "Error");
                });
        },
        getSubDivisions() {
            this.$store.dispatch("post", { uri: "getSubDivisions", data: {} })
                .then((response) => {
                    this.sub_divisions = response.data.data || [];
                })
                .catch(() => {});
        },
        discard() {
            this.circle = {
                circle_id: "",
                sub_division_id: "",
                circle: "",
                email: "",
                address: "",
            };
            this.errors = [];
            this.status = true;
            this.index();
            if (this.$refs.sub_division_id) this.$refs.sub_division_id.focus();
        },
        onPageChange(page) {
            this.meta.page = page;
            this.index();
        },
        search() {
            this.meta.page = 1;
            this.index();
        },
        sort(field) {
            this.meta.keyword = field;
            this.meta.order_by = this.meta.order_by === "asc" ? "desc" : "asc";
            this.index();
        },
    },
};
</script>
<style scoped>
input:focus, select:focus { outline: none; box-shadow: 0 0 0 0 transparent; }
</style>
